exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.modal-header .close[data-v-5df54133] {\n  margin-top: -4px !important;\n  font-size: 30px;\n}\n.fiber_error[data-v-5df54133] {\n  color: red;\n  margin-top: 7px;\n}\n", ""]);

// exports
